import React from 'react'
import Loader from "react-loader-spinner";

export const Loading = () => (
  <div className="animated fadeIn pt-3 text-center">
    <Loader type="ThreeDots" color="#75BC1E" height={80} width={80} />
  </div>
);
